const en = {
    lang: 'en_US',
    JHPleaseEnter:'please enter {0}',
    JHPleaseSelect:'please select {0}',
    JHSelect:'select {0}',
    JHPleaseApply:'please apply {0}',
    JHIllegality:'{0} illegal',
    JHInvalid:'{0} invalid',
    JHNotOperated:'{0} not operated',
    JHSendMessage:'{0} send message',
    JHSubmit:'{0} submit',
    JHGetFail:'{0} get fail',
    JHExecuteError:'{0} execute fail',
    JHFail:'{0} fail',
    JHSuccess:'{0} success',
    JHStatus:'{0} status',
    JHDisable:'{0} disable',
    JHPayment:'{0} payment',
    JHRepeat:'{0} repeat',
    JHNotFound:'not found {0}',
    JHMoreLength:'length not exceed {0}',
    JHTextDescription:'fill in {0}, within {1} words',
    JHAB:'{0} {1}',
    JHABC:'{0} {1} {2}',
    JHABCD:'{0} {1} {2} {3}',
    JHExisting: '{0} already exists',
    JHNewlyAdd: 'Create {0}',
    JHNotExist:'not exist',
    JHMerchant:'merchant',
    JHDevice:'device',
    JHStock:'stock',
    JHSurplus:'surplus',
    JHWarning:'warning',
    JHStream:'stream',
    JHPay:'pay',
    JHAli:'Alipay',
    JHWX:'wechat',
    JHUnion:'union',
    JHUnion1:'union1',
    JHJKP:'JKP',
    JHSpecial:'special',
    JHTogether:'together',
    JHBCCB:'CCB',
    JHBICBC:'ICBC',
    JHBEMS:'EMS',
    JHBABC:'ABC',
    JHTrade:'trade',
    JHAdd:'add',
    JHEdit:'edit',
    JHDelete:'delete',
    JHRevert:'revert',
    JHQuery:'query',
    JHSearch:'search',
    JHView:'view',
    JHConfirm:'confirm',
    JHCancel:'cancel',
    JHClose:'close',
    JHArrange:'arrange',
    JHNext:'next',
    JHPrevious:'previous',
    JHLink:'link',
    JHDefault:'default',
    JHNot:'not',
    JHAuto:'auto',
    JHManual:'manual',
    JHVerify:'verify',
    JHMode:'mode',
    JHRemark:'remark',
    JHAuth:'auth',
    JHSerial:'serial',
    JHCode:'code',
    JHName:'name',
    JHSimple:'simple',
    JHDescription:'description',
    JHOperate:'operate',
    JHPerson:'person',
    JHStore:'store',
    JHAddress:'address',
    JHHeader:'header',
    JHData:'data',
    JHClass:'class',
    JHType:'type',
    JHPattern:'pattern',
    JHCustom:'custom',
    JHStrategy:'strategy',
    JHKeywords:'keywords',
    JHUnify:'unify',
    JHAlone:'alone',
    JHNo:'number',
    JHRule:'rule',
    JHPrefix:'prefix',
    JHSuffix:'suffix',
    JHTime:'time',
    JHFormatter:'formatter',
    JHLength:'length',
    JHNum:'num',
    JHGrater:'grater',
    JHLess:'less',
    JHEqual:'qqual',
    JHForm:'form',
    JHYear:'year',
    JHMonth:'month',
    JHDay:'day',
    JHWeek:'week',
    JHHour:'hour',
    JHMinute:'minute',
    JHSecond:'second',
    JHMillisecond:'millisecond',
    JHTimeStamp:'time stamp',
    JHAnd1:'and1',
    JHAnd2:'and2',
    JHBatch:'batch',
    JHForever:'forever',
    JHReason:'reason',
    JHFunction:'function',
    JHOriginal:'original',
    JHLog:'log',
    JHError:'error',
    JHActual:'actual',
    JHCredit:'credit',
    JHUpper:'upper',
    JHLower:'lower',
    JHLastC:'last',
    JHThisC: "this",
    JHNextC:'next',
    JHPLUCenter:'PLU Center',
    JHArea:'area',
    JHDepot:'depot',
    JHInfo:'info',
    JHContent:'content',
    JHNote:'note',
    JHList:'list',
    JHPurchase:'purchase',
    JHUse:'use',
    JHAllot:'allot',
    JHEnter:'enter',
    JHSale:'sale',
    JHStockIn:'stock in',
    JHRefundOut:'refund Out',
    JHPutIn:'put in',
    JHPutOut:'put out',
    JHOther:'other',
    JHInventory:'inventory',
    JHOrderPlan:'order ',
    JHProfitLoss:'profit loss',
    JHLoss: 'loss',
    JHProfitBill: 'profit',
    JHUnconfirmed:'unconfirmed',
    JHClean:'clean',
    JHPutUp:'put up',
    JHDetail:'detail',
    JHAmount:'amount',
    JHStaging:'staging',
    JHSaved:'saved',
    JHWaitVerify:'wait verify',
    JHVoided:'voided',
    JHClosed:'closed',
    JHFinish:'finish',
    JHReviewed:'reviewed',
    JHHedged:'hedged',
    JHUnKnow:'unKnow',
    JHLoad:'load',
    JHLoading:'loading',
    JHPLUName:'PLU name',
    JHUnit:'unit',
    JHAmountWeight:'amount weight',
    JHSubTotal:'sub total',
    JHQR:'QR',
    JHStage:'stage',
    JHSave:'save',
    JHRevoke:'revoke',
    JHReview:'review',
    JHHedge:'hedge',
    JHRepeal:'repeal',
    JHRestore:'restore',
    JHReturn:'return',
    JHSupplier:'supplier',
    JHFirst:'first',
    JHCreate:'create',
    JHPLU:'PLU',
    JHLibrary:'library',
    JHWeighting:'weighing',
    JHByThePiece:'by the piece',
    JHPCSing:'PCSing',
    JHPurchasePrice:'purchase price',
    JHPrice:'unit price',
    JHMoney:'price',
    JHSummary:'summary',
    JHSettle:'settle',
    JHDetails: "Details",
    JHCounter:'counting',
    JHConfig:'config',
    JHSetting:'setting',
    JHDaySettle:'day settle',
    JHWeekSettle:'week settle',
    JHMonthSettle:'month settle',
    JHYearSettle:'year settle',
    JHSingle:'single',
    JHInit:'initial',
    JHNormal:'normal',
    JHBurden:'minus',
    JHZero:'zero',
    JHTobeSettled:'to be settled',
    JHSettled:'settled',
    JHDocument:'document',
    JHBRScale:'label scale',
    JHPOSScale:'POS scale',
    JHTKScale:'truck scale',
    JHProductsSummery:'products summery',
    JHClassSummery:'class summery',
    JHWareHouseSummery:'warehouse summery',
    JHProfit:'gross profit',
    JHProfitTips: 'gross profit = Total Outbound Amount (Negative) - Total Outbound Cost',
    JHGross:'gross margin',
    JHGrossTips:'gross margin = Total outbound amount==0? (Total amount received=0? 0: (Profit/Total amount received): (Profit/Total amount received)',
    JHRefer:'reference',
    JHExperience:'experience',
    JHWriteIn:'write in',
    JHPhysics:'physics',
    JHLogic:'logic',
    JHRecovery:'recovery',
    JHOneToMultiple:'One product with multiple sales',
    JHRatio:'ratio',
    JHSalePlu:'sale PLU',
    JHMaterial:'material',
    JHGroupPlu:'group PLU',
    JHFormula:'formula',
    JHProduct:'product',
    JHMachining:'process',
    JHCost:'cost',
    JHDescribe:'describe',
    JHRepeatFormula:'formula exist, please try again',
    JHPhonePayWarning:'Merchants allow users to use their phone numbers to store and deduct payments, and users default to activating this feature',
    JHAreaDescription1:'Implement partition function and summary clearing for warehouses, and users without specific needs do not need to add partitions',
    JHDepotDescription1:'Inventory settlement summary dimension, non specific users can use the default warehouse',
    JHDepotDescription2:'If a store is associated, the sales returns and other inventory information generated by the store will be automatically associated with the default warehouse of this store; If there is no associated store, the inventory information such as sales returns generated by the merchant will be automatically associated with the merchant‘s default warehouse',
    JHDepotDescription3:'select a store that is not associated with the default global warehouse',
    JHDepotDescription4:'Set this warehouse as the default inventory under the merchant/store, and automatically associate sales return inventory with this warehouse',
    JHDepotDescription7:'Changing the default settings may affect real-time inventory summary. Do you want to confirm this operation',
    JHDepotDescription8:'default configuration,not mandatory to set it',
    JHDepotDescription9:'no default configuration,not mandatory to set it',
    JHDepotDescription10:'Changing the associated store may affect real-time inventory summary. Do you want to confirm this operation',
    JHDepotDescription11:'Related regional information, if necessary, merchants can implement data aggregation based on the region',
    JHNoteDescription1:'Implement grouping function for bills, and users without specific needs do not need to add them. The system will automatically create default classifications when creating bill types',
    JHNoteDescription2:'The merchant specifically supports bill business by selecting the bill strategy to be added from the supported bill strategies in the system',
    JHNoteDescription3:'Please select the desired strategy from the supported ticket strategies in the system. If the desired strategy is not found, please contact the dealer for feedback from the distributor',
    JHNoteDescription4:'Unified strategy: The bill number is obtained using unified rules; Independent strategy: Independent strategy for configuring the use of bill numbers',
    JHNoteDescription5:'The sequence value of the current bill serial number rule',
    JHNoteDescription6:'Year Month Day (210821) | Year Month (2108) | Time Stamp 1 (seconds) | Time Stamp 2 (milliseconds)',
    JHNoteDescription7:'Whether to automatically approve the bill after it is successfully created. Automatically approve the bill and directly operate the inventory. To approve the bill, the user needs to approve it before operating the inventory',
    JHNoteDescription8:'Automatically approve according to rules (no duplicates), customizable and modifiable (currently not supported)',
    JHNoteDescription9:'Bill remarks definition',
    JHNoteDescription10:'Document supplier, optional',
    JHNoteDescription11:'Select the warehouse to operate according to the needs',
    JHNoteDescription12:'Product library: Select batch addition for product library (recommended); Quantity: added to the list of pre created lines',
    JHNoteDescription13:'Add blank line quantity to fill in bill details（0 < n <= 50）',
    JHNoteDescription14:'Click: Select Warehouse Add',
    JHNoteDescription15:'Double click: Deselect the selected warehouse',
    JHNoteDescription16:'Check, organize and eliminate invalid bill details',
    JHStockDescription1:'Merchant‘s inventory flow to be settled and settled',
    JHStockDescription2:'Inventory flow of the store to be settled and settled',
    JHStockDescription11:'Regional inventory flow to be settled and settled',
    JHStockDescription3:'Warehouse inventory flow to be settled and settled',
    JHStockDescription4:'The inventory flow of goods to be settled and settled, commonly known as "single item purchase, sales, and inventory"',
    JHStockDescription5:'Click: Select single item query',
    JHStockDescription6:'Double click: Reset item selection',
    JHStockDescription7:'Merchant inventory status information',
    JHStockDescription8:'Store inventory status information',
    JHStockDescription9:'Warehouse inventory status information',
    JHStockDescription10:'Inventory=Real time inventory+Balance inventory',
    JHSettleDescription1:'Query all warehouses of merchants and summarize and settle real-time inventory information of all warehouses',
    JHSettleDescription2:'Automatic settlement type',
    JHSettleDescription3:'During the settlement period, ensure that no more transactions occur. Please ensure that the transactions are in a stopped state before settlement. If there are transactions in the middle process that cause differences in settlement data, the account will not bear the consequences on the merchant‘s own!!!',
    JHSettleDescription4:'Query all warehouses in the store and summarize and settle real-time inventory information of all associated warehouses',
    JHSettleDescription5:'Query all warehouses in the region and summarize and settle real-time inventory information of all associated warehouses',
    JHSettleDescription6:'Query the warehouse and summarize real-time inventory information of the settlement warehouse',
    JHSystemCreateDefault:'System generated by default, customizable',
    JHDBError1:'Database update failed',
    JHDataError1:'Invalid data',
    JHFormulaOverwriteTips:'The product you added already has the following formula. Are you sure to overwrite it?',
    JHLevelTips:'Used to classify different levels and associate them with stores. Modifying product prices in multiple stores can be modified based on the level',
    JHRecycle:'recycle',
    JHFile:'file',
    JHMerge:'merge',
    JHTakeEffect:'take effect',
    JHReset:'reset',
    JHCover:'cover',
    JHCurrent:'current',
    JHCloudServices:'cloud services',
    JHAssistant:'assistant',
    JHShortcutPage:'shortcut page',
    JHHotKey:'hot key',
    JHModel:'model',
    JHTrain:'training',
    JHHandle:'handle',
    JHVersion:'version',
    JHUpgrade:'upgrade',
    JHHistory:'history',
    JHSelected:'selected',
    JHPicture:'picture',
    JHPlatform:'platform',
    JHTips:'tips',
    JHUser:'User',
    JHSelectAll:'select All',
    JHEmpty:'empty',
    JHAvatar:'head sculpture',
    JHIssued:'issued',
    JHParent:'parent',
    JHBarcode:'barcode',
    JHOffTheShelf:'off the shelf',
    JHShelf:'shelf',
    JHStopSelling:'stop selling',
    JHOutOfStock:'out of stock',
    JHArchives:'files',
    JHArticleNumber:'cargo number',
    JHQuantifier:'quantifier',
    JHSaveAsWeight:'save as weight',
    JHTare:'tare',
    JHPercentage:'percentage',
    JHWeight:'weight',
    JHTaxRate:'tax rate',
    JHPrint:'print',
    JHSign:'sign',
    JHBitmap:'bitmap',
    JHDate:'date',
    JHInteger:'integer',
    JHPackage:'package',
    JHUsed:'used',
    JHText:'text',
    JHManualDiscount:'manual discount',
    JHAutoDiscount:'auto discount',
    JHActivationDate:'activation date',
    JHRange:'range',
    JHNotUsed:'not used',
    JHTaxAmount:'tax amount',
    JHBasic:'basic',
    JHGrade:'grade',
    JHInput:'input',
    JHGeneral:'general',
    JHTimeSpan:'time span',
    JHSingleCalculation:'single calculation',
    JHForbidSale:'forbid sale',
    JHMember:'member',
    JHSystem:'system',
    JHNoTax:'no tax',
    JHExtraPriceTax:'extra price tax',
    JHInPriceTax:'in price tax',
    JHAfterTaxPrice:'after tax price',
    JHAs:'as',
    JHImport:'import',
    JHDeDuplication:'deduplication',
    JHDeDuplicationTips:'deduplication tips',
    JHPriceChange:'price change',
    JHFast:'fast',
    JHDoubleClick:'double click',
    JHDecompose:'decompose',
    JHAssemble:'assemble',
    JHReversible:'reversible',
    JHRenew:'renew',
    JHTel:'Tel',
    JHCostsSalculateTips:'recalculate costs based on proportion',
    JHPerfect:'perfect',
    JHTemplate:'template',
    JHRentOut:'rent out',
    JHMarket:'market',
    JHEarlyWarning:'early warning',
    JHRefuse:'refuse',
    JHRenting:'renting out',
    JHUnbinding:'unbinding',
    JHYes:'Yes',
    JHNoNo:'No',
    JHBusinessLicense:'business license',
    JHHealthCertificate:'health certificate',
    JHIDCard:'ID card',
    JHHygieneLicense:'hygiene license',
    JHInspection:'inspection',
    JHRecords:'records',
    JHCopy:'copy',
    JHAllocation:'allocation',
    JHCharacterSet:'character set',
    JHOnline:'online',
    JHOffline:'offline',
    JHBeBusy:'busy',
    JHPeriodOfValidity:'period of validity',
    JHEquipment:'equipment',
    JHExpire:'expire',
    JHAbnormal:'abnormal',
    JHIncomplete:'incomplete',
    JHProject:'project',
    JHMore:'more',
    JHPickUp:'pick up',
    JHAsync:'sync',
    JHSort:'sort',
    JHTag:'tag',
    JHQualifications:'qualifications',
    JHBlurb:'brief introduction',
    JHAlias:'another name',
    JHLegalPerson:'legal person',
    JHOrigin:'origin',
    JHPlantation:'plantation',
    JHSlaughterhouse:'slaughterhouse',
    JHEvery:'every',
    JHSunday:'Sunday',
    JHMonday:'Monday',
    JHTuesday:'Tuesday',
    JHWednesday:'Wednesday',
    JHThursday:'Thursday',
    JHFriday:'Friday',
    JHSaturday:'Saturday',
    JHStatistics:'statistics',
    JHAverage:'average',
    JHTheSame:'theSame',
    JHCreateFileSlowTips:'generating files is slow. check to continue waiting or not',
    JHImportPLUTips1: "If the same number exists, the original data will be overwritten (if the overwritten data has information that does not appear in the table, it will be overwritten), and special symbols cannot be used",
    JHImportPLUTips2: "If you need to modify the file name, please add it after the template file name",
    JHImportPLUTips3: "If the file size exceeds 1M, it needs to be split into multiple files and uploaded in batches",
    JHEntityCard: "entity card",
    JHExample: "example",
    JHStepNum: "step num",
    JHComplete:'{0} complete',
    JHAlready:'already {0}',
    JHBaseON:'based on {0}',
    JHUsingAs:'using {0} as {1}',
    JHTimeOut:'{0} time out',
    JHFixed:'fixed {0}',
    JHWithin:'within {0}',
    JHWithout:'out of {0}',
    JHNotHave:'no {0}',
    JHTheStep:'step {0}',
    JHWhether: "whether{0}",
    JHLogReport:'log report',
    JHNumberOfTransactions:'number of transactions',
    JHRefund:'refund',
    JHRefundTips: "After the refund, the cash payment portion will be refunded to the stored balance of the membership card",
    JHAmountAfterDiscount:'amount after discount',
    JHRoundedAmount:'rounded amount',
    JHCardPayment:'card payment',
    JHGikayun:'gikayun',
    JHCloudPay:'cloud pay',
    JHReport:'report',
    JHCloudFlashPayment:'cloud flash payment',
    JHLongPayment:'long payment',
    JHOrder:'order',
    JHPayThrough:'pay through',
    JHRecharge:'recharge',
    JHConsume:'consume',
    JHIntegral:'integral',
    JHAccumulate:'accumulate',
    JHDiscount:'discount',
    JHSpecialOffer:'special offer',
    JHCash:'cash',
    JHScene: 'scene',
    JHGroup:'group',
    JHMobile:'mobile',
    JHPaymentLimit:'payment limit',
    JHUserName:'user name',
    JHBalance:'balance',
    JHGive:'give',
    JHBalances:'balances',
    JHMobileBalance:'phone number storage',
    JHVideo:'video',
    JHStall:'stall',
    JHStallNo:'stall No.',
    JHExchange:'exchange',
    JHBoothNo:'booth No.',
    JHContacts:'contacts',
    JHTotalNumber:'total number',
    JHMainBusiness:'main business',
    JHClear:'clear',
    JHReplace:'replace',
    JHRandom:'random',
    JHAutoBatchAllocat:'Random batch automatic allocation',
    JHRandomAllocaOfDS:'Random allocation of designated stalls',
    JHDesReplace:'1V1 designated booth replacement',
    JHAll:'all',
    JHToBeAllocated:'to be allocated',
    JHNoPermission:'No permission temporarily',
    JHAtLeast:'at least',
    JHStart:'start',
    JHEnd:'end',
    JHApply:'apply',
    JHDownload:'download',
    JHUpload:'upload',
    JHAnalysis:'analysis',
    JHAutoInspectionDesp:'Automatic creation means that the system will uniformly create inspection records with a status of incomplete the next day',
    JHInspectionTimeTips:'Fixed interval inspection, interval duration cannot exceed 15 days',
    JHFireFighting:'fire fighting',
    JHNHealth:'health',
    JHNRubbish:'rubbish',
    JHNLooks:'looks',
    JHInterval:'interval',
    JHToBe:'treat {0}',
    JHExport:'export {0}',
    JHReload:'reload {0}',
    JHInProcessOf:'in process of {0}',
    JHManage: '{0} manage',
    JHServiceCharge: 'service charge',
    JHCommand: 'command',
    JHCommissionSharing: 'Commission sharing',
    JHWithdrawal: 'Withdrawal',
    JHDistributor: 'Agent',
    JHAuthCode: 'Auth Code',
    JHTruename: 'truename',
    JHBatchNumber: 'Batch number',
    JHPublicPraise: 'public praise',
    JHFMCG: 'FMCG',
    JHBinding: 'binding',
    JHUnbound: 'unbound',
    JHDevice30DayTips: 'The device has been bound for more than 30 days and unbinding is not allowed',
    JHOr: 'or',
    JHVerificationCode: 'Verification code',
    JHInstructionsForUse: 'Instructions for use',
    JHUnbindingTips1: 'This unbinding only supports unbinding devices that have not been enabled for cloud payment. If you have enabled cloud payment, please contact the merchant to unbind',
    JHUnbindingTips2: 'If the device needs to be unbound, it must be ensured that the unbound person can operate the device, otherwise the operation steps cannot be executed.',
    JHUnbindingTips3: 'Input device Mac and send verification code; If the prompt indicates that the device is not offline, program 44, quickly program+correct',
    JHUnbindingTips4: 'After the cloud payment displays a horizontal line, click "Send Verification Code" again',
    JHUnbindingTips5: 'Based on the successfully returned prompt message, program 44, quickly program+correct, then correct again, and check according to the printed receipt',
    JHUnbindingTips6: '"Unbind - Dealer Phone Number: Verification Code"',
    JHUnbindingTips7: 'View the 6-digit verification code, enter it at the verification code, unbind the device, and check the unbinding status based on the returned information',
    JHUnbindingTips8: 'And re correct to see if there is a re bound QR code.',
    JHOperator: 'operator',
    JHCompany: 'company',
    JHEmail: 'E-mail',
    JHCustomerService: 'customer service',
    JHWithdrawable: 'Withdrawable',
    JHToBeCredited: 'To be credited',
    JHInvoice: 'invoice',
    JHBill: 'bill',
    JHDimension: 'Dimension',
    JHCashierScale: 'Cashier scale',
    JHHangingScale: 'Hanging scale',
    JHBluetooth: 'Bluetooth',
    JHThirdParty: 'third party',
    JHMonitor: 'monitor',
    JHSelfService: 'self-help',
    JHRate: 'Rate',
    JHOfficialAccount: 'official account',
    JHChannel: 'channel',
    JHChannelChangeTips: "The change of this strategy will affect the user's payment channel, please do not change it arbitrarily",
    JHChannelChangeTips2: "This operation will change the user's payment channel, please operate with caution",
    JHTerminal: 'terminal',
    JHCounterBar: 'counter',
    JHAuthentication: 'authentication',
    JHTotal: 'Total {0}',
    JHShenyang: 'Shenyang',
    JHShanghai: 'Shanghai',
    JHActivation: 'activation',
    JHTest: 'test',
    JHSecretKey: 'secret key',
    JHPublicKey: 'Public Key',
    JHPrivateKey: 'Private key',
    JHCertificate: 'certificate',
    JHBranch: 'branch',
    JHAccount: 'account number',
    JHPassword: 'password',
    JHGroupNumber: 'Group number',
    JHCustomerNo: 'Customer No',
    JHSignature: 'signature',
    JHWay: 'way',
    JHTokenURL: 'token url',
    JHAPP: 'APP',
    JHPaymentCode: 'Payment code',
    JHRateTips1: 'UnionPay rates can be modified by clicking on the cloud payment rate button',
    JHRateTips2: 'Cost 2.0 ‰, profit 1.8 ‰, distributor 50% (0.9 ‰), precision letter 50% (9 ‰)',
    JHRateTips3: 'Cost 2.0 ‰, profit 1.2 ‰, distributor 50% (0.6 ‰), precision letter 50% (6 ‰)',
    JHRateTips4: 'Cost 2.0 ‰, profit 1.0 ‰, distributor 50% (0.5 ‰), precision letter 50% (5 ‰)',
    JHRateTips5: 'Cost 2.0 ‰, profit 0.9 ‰, distributor 50% (0.45 ‰), precision letter 50% (4.5 ‰)',
    JHRateTips6: 'Cost 2.0 ‰, profit 0.8 ‰, distributor 50% (0.4 ‰), precision letter 50% (4 ‰)',
    JHRateTips7: 'Cost 2.0 ‰, profit 0.7 ‰, distributor 46% (0.322 ‰), precision letter 54% (3.78 ‰)',
    JHRateTips8: 'Cost 2.0 ‰, profit 0.6 ‰, dealer 43% (0.258 ‰), precision letter 57% (3.42 ‰)',
    JHRateTips9: 'Cost 2.0 ‰, profit 0.5 ‰, distributor 40% (0.2 ‰), precision letter 60% (3 ‰)',
    JHCCBRateTip1: 'Profit 1.8 ‰, distributor 50% (0.9 ‰), precision letter 50% (0.9 ‰)',
    JHCCBRateTip2: 'Profit 1.2 ‰, distributor 50% (0.6 ‰), precision letter 50% (0.6 ‰)',
    JHCCBRateTip3: 'Profit 1.0 ‰, distributor 50% (0.5 ‰), precision letter 50% (0.5 ‰)',
    JHCCBRateTip4: 'Profit 0.9 ‰, distributor 50% (0.45 ‰), precision letter 50% (0.45 ‰)',
    JHCCBRateTip5: 'Profit 0.8 ‰, distributor 50% (0.4 ‰), precision letter 50% (0.4 ‰)',
    JHCCBRateTip6: 'Profit 0.7 ‰, dealer 46% (0.322 ‰), precision letter 54% (0.378 ‰)',
    JHCCBRateTip7: 'Profit 0.6 ‰, dealer 43% (0.258 ‰), precision letter 57% (0.342 ‰)',
    JHCCBRateTip8: 'Profit 0.5 ‰, distributor 40% (0.2), precision letter 60% (0.3 ‰)',
    JHRateAddTips: "We haven't found any UnionPay payment rates yet. Do you want to add them",
    JHLoginTips1: 'Welcome to the agent platform',
    JHLoginTips2: 'Please log in with your own account and password',
    JHLoginTips3: "Don't have an account yet? Go register",
    JHLoginTips4: 'agent Management Platform',
    JHForgetPWD: 'Forgot password',
    JHRememberPWD: 'Remember password',
    JHLogin: 'Login',
    JHLogout: 'Logout',
    JHObtain: 'Obtain',
    JHCountry: 'country',
    JHNewPassword: 'new password',
    JHNewPasswordTips: 'The two passwords are different, please confirm again',
    JHRegister: 'Register',
    JHWithdrawalTips: 'The requested withdrawal amount cannot be greater than the withdrawable amount',
    JHSigning: 'Signing',
    JHResult: 'result',
    JHOperation: 'Operation',
    JHFrontalView: 'frontal view',
    JHReverseView: 'Reverse view',
    JHIDNo: 'ID No',
    JHIndividualBusiness: 'individual business',
    JHAbbreviation: 'abbreviation',
    JHPhoto: 'photo',
    JHShopSign: 'shop sign',
    JHIndoorScene: 'indoor scene',
    JHEstablishAnAccount: 'establish an account',
    JHBankCard: 'Bank Card',
    JHBank: 'Bank',
    JHFullName: 'full name',
    JHProvincialCityCode: 'Provincial and City Code',
    JHComparisonTable: 'Comparison Table',
    JHBusinessScenario: 'Business scenario',
    JHSelfTest: 'Self Test',
    JHSaveSubmitThirdParty: 'Save and submit for third-party review',
    JHRateTips10: 'The merchant already has a cloud payment rate configuration. Do you want to use the configured rate?',
    JHEnterprise: 'enterprise',
    JHParameter: 'parameter',


    JHLeadSealManage:'Lead seal management',
    JHLeadSealManageEdit:"Complete lead seal information",
    JHDeviceMac:'Equipment number',
    JHSealCode:'Lead seal number',
    JHLeadSealStatus:'Lead sealed state',
    JHUnpacked:'Unpacked',
    JHSealedLead:'Sealed with lead',
    JHUnlocked:'Unlocked',
    JHApproved:'Approved',
    JHReviewFailed:'Review failed',
    JHOperatorType:'Operator type',
    JHFactory:'factory',
    JHFac:'factory',
    JHLeadSeal:'Lead seal',
    JHLeadSealingAndUnsealing:'Lead sealing and unsealing',
    JHBeforeOperation:'Before operation',
    JHAfterOperation:'After operation',
    JHPhotograph:'photograph',
    JHRetake:'Retake',
    JHPleaseTakeAPhotoFirst:'Please take a photo first',
    JHAppNo:'Application serial number',
    JHDeviceType:'Equipment type',
    JHService:'service',
    JHCalibration:'calibration',
    JHPleaseUploadPictures:'Please upload pictures',
    JHStandard:'standard',
    JHImageUploadMethod:'Image upload method',
    JHUploadMethod:'Upload method',
    JHLocalImg:'Local images',
    JHIsOpenCamera:'Opening camera, please wait',
    JHNoCamera:'There are currently no available cameras, please check your hardware equipment',
    JHCamera:'camera',
    JHPleaseUploadDevicePictures:'Please upload device images',
    JHPleaseUploadSealPictures:'Please upload a picture of the lead seal',
    JHNameplate:'Nameplate',
    JHFuBei:'Fu Bei',
    JHSaoBei:'Sao Bei',
    JHAlreadyRealName:'Already registered with real name',

    ChangePassword:'Change Password',
    PleaseEnterThePasswordAgain:'Please Enter The Password Again',
    JHPasswordFormatRequirements:'Password format requirements: The password must be at least 12 characters long, consisting of uppercase and lowercase letters, numbers, and special characters. Additionally, consecutive repeating characters are prohibited',
    PasswordNotSpecifications:'The password does not meet the specifications',
    PEnterNewPwd:'Please enter a new password',
    PwdNotGoodPEnter:'The password does not meet the requirements. Please re-enter it', remindEditPwdTips:'Your password has not been changed for over 90 days. For the security of your account, please change your password',
    toEditPwd:'Go to change your password',
    noReminder30:'No reminder within 30 days',
    loginByMobile:'Mobile number login',
    AccountAndPasswordLogin:'Account and password login',
    fotText1:'Record number: Shanghai ICP No. 12013583-1',
    fotText2:'Shanghai Public Security Network: 31011202001146',
    fotText3:'©Copyright 2019 Shanghai Jinghan Information Technology Co., Ltd. All rights reserved',
    passwordTips:'Your password does not meet the requirements set by the Ministry of Public Security. Please click on "Forgot Password", modify your password as required, and log in again',
    PleEnterYourMobileNumber:'Please Enter Your Mobile Number',
    GetVerificationCode:'Get verification code',

}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/en.js